/* @flow */

export default class ResetPasswordRequest {
  email: string;
  password: string;
  token: string;
  twoFactorPin: string;
  smsCode: string;
}
